
import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

const LanguageSwitcher = () => {
  const location = useLocation();
  const { pathname } = location;
  const { i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(pathname.includes('blog'));

  // Set initial language based on i18n
  useEffect(() => {
    const browserLanguage = navigator.language.split('-')[0];
    if (browserLanguage === 'fr' || browserLanguage === 'en') {
      i18n.changeLanguage(browserLanguage);
    }
  }, [i18n]);
  
  // Handle scroll effect
    useEffect(() => {
        if (pathname.includes('blog')) {
            return;
        }
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const languages = [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'Français' }
    ];

    const changeLanguage = (langCode: string) => {
        i18n.changeLanguage(langCode);
        console.log(`Language changed to ${langCode}`);
    };

  const currentLanguage = i18n.language || 'en';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={cn(
        "flex items-center gap-1 transition-colors duration-300 text-sm font-medium focus:outline-none",
        isScrolled
          ? "text-developer-neutral dark:text-gray-300 hover:text-developer-accent dark:hover:text-developer-accent-light"
          : "text-white hover:text-gray-200"
      )}>
        <Globe className="h-4 w-4" />
        <span>{currentLanguage === 'en' ? 'EN' : 'FR'}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white dark:bg-developer-dark dark:border-gray-700">
        {languages.map((lang) => (
          <DropdownMenuItem 
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`cursor-pointer ${currentLanguage === lang.code ? 'font-bold' : ''} dark:text-white dark:hover:bg-gray-800`}
          >
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
